/* Responsibility: Creates the pagination element */
import dom from '../../lib/dom.js';
import preconditions from '../../lib/preconditions.js';

const checkPreconditions = preconditions('pagination', {
    eventHub: 'eventHub',
    pagination: 'element',
    resultViewCriteria: 'object',
    template: 'function',
});

let renderTemplate;

function selectPage(params, e) {
    e.preventDefault();
    const tag = dom.closestWithTagName('A', e.target);
    const pageNumber = tag.getAttribute('data-pagenr');
    params.resultViewCriteria.pageNumber = pageNumber;
    params.resultViewCriteria.pageNumberChanged = true;
    params.eventHub.publish('resultViewCriteria:changed');
}

function createListOfPreviousPages(numPages, currentPage) {
    const minPageNr = Math.min(currentPage - 5, numPages - 9);
    const firstPage = Math.max(minPageNr, 1);
    const previousPages = [];
    for (let i = firstPage; i < currentPage; i++) {
        previousPages.push(i);
    }
    return previousPages;
}

function createListOfConsecutivePages(numPages, firstPage, currentPage) {
    const lastPage = Math.min(numPages, firstPage + 9);
    const consecutivePages = [];
    for (let i = currentPage + 1; i <= lastPage; i++) {
        consecutivePages.push(i);
    }
    return consecutivePages;
}

function updatePagination(pagination, data) {
    const numPages = data.totalPages;
    const currentPage = data.currentPage;
    const previousPages = createListOfPreviousPages(numPages, currentPage);
    const consecutivePages = createListOfConsecutivePages(numPages, previousPages[0] || 1, currentPage);

    pagination.innerHTML = renderTemplate({
        showPagination: numPages > 1,
        rewind: currentPage > 2,
        previousPages,
        previousPage: currentPage - 1,
        currentPage,
        nextPage: currentPage + 1,
        consecutivePages,
    });
}

function setupEventListener(params) {
    dom.on(params.pagination, 'click', '.pageEvent', (e) => selectPage(params, e));
    params.eventHub.subscribe('polling-response', (data) => updatePagination(params.pagination, data));
    params.eventHub.subscribe('changed-results', (data) => updatePagination(params.pagination, data));
}

export default function (params) {
    checkPreconditions(params);
    setupEventListener(params);
    renderTemplate = params.template;
}
